import { render, staticRenderFns } from "./Privacy-policy.vue?vue&type=template&id=79175bb5&"
import script from "./Privacy-policy.vue?vue&type=script&lang=js&"
export * from "./Privacy-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports